package pt.at.oss.kotlin.manual.schema.common.relevantdates

import pt.at.oss.kotlin.manual.storage.common.relevantdates.RelevantDates
import pt.lightweightform.kotlin.schema.DateStringSchema
import pt.lightweightform.kotlin.schema.RecordSchema
import pt.lightweightform.kotlin.type.validator.ValidationErrors
import pt.lightweightform.kotlin.util.appendToPath

/**
 * RelevantDatesSchema Schema object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
class RelevantDatesSchema : RecordSchema<RelevantDates>(name = "relevantDates") {

    val registrationReqDateSchema: DateStringSchema = DateStringSchema(name = "registrationReqDate")
    val forecastStartDateSchema: DateStringSchema = DateStringSchema(name = "forecastStartDate")
    val msidDecisionDateSchema: DateStringSchema = DateStringSchema(name = "msidDecisionDate")
    override fun isValid(value: RelevantDates?): Boolean {
        return value == null || (
            registrationReqDateSchema.isValid(value.registrationReqDate) &&
                forecastStartDateSchema.isValid(value.forecastStartDate) &&
                msidDecisionDateSchema.isValid(value.msidDecisionDate)
            )
    }

    override fun validate(value: RelevantDates?, path: String): ValidationErrors {
        val validator = super.validate(value, path)
        if (value === null) {
            return validator
        }
        validator.addErrors(registrationReqDateSchema.validate(value.registrationReqDate, appendToPath(path, "registrationReqDate")))
        validator.addErrors(forecastStartDateSchema.validate(value.forecastStartDate, appendToPath(path, "forecastStartDate")))
        validator.addErrors(msidDecisionDateSchema.validate(value.msidDecisionDate, appendToPath(path, "msidDecisionDate")))
        return validator
    }
}
